import { useCallback } from 'react';
import { MERGE_PATCH_HEADERS, useApiCall } from './apiHelpers';

const useDeleteCommunicationInput = () => {
  const { authFetch, isReady, run, isLoading, error } = useApiCall();

  const deleteCommunicationInput = useCallback(
    async (id: number): Promise<boolean> => {
      if (!isReady) return false;
      const outcome = await run(
        () => authFetch(`/communication_inputs/${id}`, {
          method: 'PATCH',
          headers: MERGE_PATCH_HEADERS,
          body: JSON.stringify({ deletedAt: new Date().toISOString() }),
        }),
        'Erreur lors de la suppression',
      );
      return outcome.ok;
    },
    [authFetch, isReady, run],
  );

  return { deleteCommunicationInput, isLoading, error };
};

export default useDeleteCommunicationInput;
